import React from 'react';
import './index.scss';

export const RowPad = ({ children }) => {
  return <div className="dialpad-row-pad">{children}</div>;
};

export default RowPad;
